import { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ChatbotTable from '../../components/comman/ChatBotTable';
import Card from "../../components/comman/CountCards";
import cards from './JSON/cards.json';
import { useNavigate } from "react-router-dom";
import CommonModal from "../../components/comman/modal/Modal";
import CategoryForm from "../../components/chatbots/CategoryForm";
import ConfirmationModal from "../../components/chatbots/ConfirmationModal";
import {
  fetchCategories,
  addCategory,
  updateCategory,
  deleteCategory
} from "../../redux/actions/chatbotActions/categoryActions";
import CategoryViewData from "../../components/chatbots/CategoryView";
import { fetchCountries } from "../../redux/actions/chatbotActions/countryActions";
import { fetchCards } from "../../redux/actions/chatbotActions/cardActions";
import { fetchChatbotOfferings } from "../../redux/actions/chatbotActions/offering.actions";
import CardSection from "./CardSection";


const CategorySection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { categories } = useSelector(state => ({
    categories: state.categoryReducer?.categories?.data,
  }), shallowEqual);

  const [activeCardId, setActiveCardId] = useState("category");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("add"); // add, edit, view
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [confirmOpen, setConfirmOpen] = useState(false);



  const columns = [
    { key: "id", label: "ID", width: "20%" },
    { key: "category", label: "Category", width: "40%" },
    { key: "suggested_category", label: "Suggested Category", width: "40%" },
    { key: "status", label: "Status", width: "20%" },
  ];

 

  // open modal
  const openModal = (type, category = null) => {
    setModalType(type);
    setSelectedCategory(category);
    setModalOpen(true);
  };

  // form submit handler
  const handleFormSubmit = (formData) => {
    const payload = formData.categories;
    if (modalType === "edit") {
      dispatch(updateCategory(selectedCategory.id, payload[0]));
    } else {
      dispatch(addCategory(payload));
    }
    setModalOpen(false);
  };


  // delete confirmation
  const handleDelete = (category) => {
    setSelectedCategory(category);
    setConfirmOpen(true);
  };

  const confirmDelete = () => {
    dispatch(deleteCategory(selectedCategory.id));
    setConfirmOpen(false);
  };

  const handleStatusChange = (category) => {
    dispatch(updateCategory(category.id, { status: category.status === 1 ? 0 : 1 }));
  };



  return (
    <div className="content-chatbot">
      <h1 className="text-3xl font-bold mb-8 text-gray-800">
        Category Management
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        <CardSection />
      </div>

      {activeCardId === "category" && (
        <ChatbotTable
          title="Category"
          columns={columns}
          data={categories || []}
          btnName="Add New Category"
          onAdd={() => openModal("add")}
          onView={(category) => openModal("view", category)}
          onEdit={(category) => openModal("edit", category)}
          onDelete={handleDelete}
          handleStatusClick={handleStatusChange}
        />
      )}

      {/* Category Modal */}
      <CommonModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={
          modalType === "add"
            ? "Add New Category"
            : modalType === "edit"
              ? "Edit Category"
              : "View Category"
        }
      >
        {modalType === "view" ? (
          <CategoryViewData category={selectedCategory} />
        ) : (
          <CategoryForm
            onSubmit={handleFormSubmit}
            initialData={selectedCategory}
            updateData={selectedCategory}
            btnName={modalType === "add" ? "Add Category" : "Update Category"}
            btnHide={modalType == "edit"}
          />
        )}
      </CommonModal>

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmDelete}
        title="Delete Category"
        message={`Are you sure you want to delete category "${selectedCategory?.name}"?`}
        data={selectedCategory}

      />
    </div>
  );
};

export default CategorySection;
